import { ILocalizable, IMessageId } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";

export interface IReleasesManagerState {
  filter: IReleasesManagerFilter;
  grid: IReleasesManagerGrid;
  isLoading: boolean;
  notifications: INotification[];
}
export interface IReleasesManagerFilter {
  statuses: ILocalizable[];
  data: IReleasesManagerFilterData;
}
export interface IReleasesManagerFilterData {
  filterName?: string;
  selectedStatus?: ILocalizable;
  createdDate?: string;
  releaseDate?: string;
}

export interface IReleasesManagerGrid {
  gridData: IReleaseRow[];
  selected?: IReleaseRow;
  isSearched: boolean;
}

export interface IMessage {
  messageId: IMessageId;
  text: string;
}

export interface IReleaseRow {
  releaseId: string;
  name: IMessage;
  status: IMessageId;
  releaseDate?: string;
  createdDate: string;
}

export type SelectorState = { releasesManager: IReleasesManagerState };

const getStateSelectorsProvider = () => ({
  getFilterData: (state: SelectorState) => state.releasesManager.filter.data
});

export const selectors = getStateSelectorsProvider();

export const getInitialReleasesManagerState = (): IReleasesManagerState => ({
  filter: { statuses: [], data: { createdDate: "", releaseDate: "" } },
  grid: { isSearched: false, gridData: [] },
  notifications: [],
  isLoading: false
});
